"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(stringFromString),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(stringFromBoxedString),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(stringFromCodecStringValue),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(stringFromUint8ArrayLike),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(stringFromTypeValueInput),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(stringFailureCase);

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringCases = void 0;

var debug_1 = __importDefault(require("debug"));

var debug = debug_1.default("codec:wrap:string");

var dispatch_1 = require("./dispatch");

var errors_1 = require("./errors");

var decode_1 = require("../bytes/decode");

var bytes_1 = require("./bytes");

var Utils = __importStar(require("./utils"));

var Messages = __importStar(require("./messages"));

var stringCasesBasic = [stringFromString, stringFromBoxedString, stringFromCodecStringValue, stringFromUint8ArrayLike, stringFailureCase];
exports.stringCases = [stringFromTypeValueInput].concat(stringCasesBasic);

function stringFromString(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function stringFromString$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof input !== "string")) {
            _context.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a string");

        case 2:
          if (Utils.isValidUtf16(input)) {
            _context.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.invalidUtf16Message);

        case 4:
          return _context.abrupt("return", {
            type: dataType,
            kind: "value",
            value: {
              kind: "valid",
              asString: input
            }
          });

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function stringFromBoxedString(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function stringFromBoxedString$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (Utils.isBoxedString(input)) {
            _context2.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a boxed string");

        case 2:
          return _context2.delegateYield(stringFromString(dataType, input.valueOf(), wrapOptions), "t0", 3);

        case 3:
          return _context2.abrupt("return", _context2.t0);

        case 4:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function stringFromCodecStringValue(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function stringFromCodecStringValue$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (Utils.isWrappedResult(input)) {
            _context3.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a wrapped result");

        case 2:
          if (!(input.type.typeClass !== "string")) {
            _context3.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.wrappedTypeMessage(input.type));

        case 4:
          if (!(input.kind !== "value")) {
            _context3.next = 6;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.errorResultMessage);

        case 6:
          return _context3.abrupt("return", {
            type: dataType,
            kind: "value",
            value: input.value
          });

        case 7:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function stringFromUint8ArrayLike(dataType, input, wrapOptions) {
  var info;
  return _regeneratorRuntime.wrap(function stringFromUint8ArrayLike$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (Utils.isUint8ArrayLike(input)) {
            _context4.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a Uint8Array-like");

        case 2:
          //the next series of checks is delegated to a helper fn
          bytes_1.validateUint8ArrayLike(input, dataType, wrapOptions.name); //(this fn just throws an appropriate error if something's bad)

          info = decode_1.decodeString(new Uint8Array(input));
          return _context4.abrupt("return", {
            type: dataType,
            kind: "value",
            value: info
          });

        case 5:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function stringFromTypeValueInput(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function stringFromTypeValueInput$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (Utils.isTypeValueInput(input)) {
            _context5.next = 2;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 1, "Input was not a type/value pair");

        case 2:
          if (!(input.type !== "string")) {
            _context5.next = 4;
            break;
          }

          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 5, Messages.specifiedTypeMessage(input.type));

        case 4:
          return _context5.delegateYield(dispatch_1.wrapWithCases(dataType, input.value, Object.assign(Object.assign({}, wrapOptions), {
            loose: true
          }), stringCasesBasic), "t0", 5);

        case 5:
          return _context5.abrupt("return", _context5.t0);

        case 6:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function stringFailureCase(dataType, input, wrapOptions) {
  return _regeneratorRuntime.wrap(function stringFailureCase$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          throw new errors_1.TypeMismatchError(dataType, input, wrapOptions.name, 2, Messages.notAStringMessage);

        case 1:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}